import { IQuickSearchResultSuggestion } from '../../../../types';
import { IPredSearchQuery } from '../../types';

const mapSuggestion = (queryInResp: IPredSearchQuery): IQuickSearchResultSuggestion => {
  const anyResp = queryInResp as unknown as { q: string; highlighted?: string };
  const q = anyResp.q || '';
  return {
    value: q,
    query: q.replace(/(<([^>]+)>)/gi, ''),
    highlighted: anyResp.highlighted
  };
};

export default mapSuggestion;
